controllers.controller('WithdrawCreditCardController', [
    '$scope', '$state', '$stateParams', '$ionicLoading', '$ionicModal', 'LocaleService', 'API', 'ErrorService', 'constants',
    'Validator', 'Storage', 'Utils', 'ServerTimeService', 'UserService', '$filter',
    function ($scope, $state, $stateParams, $ionicLoading, $ionicModal, LocaleService, API, ErrorService, Const,
              Validator, Storage, Utils, ServerTimeService, UserService, $filter) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.validator = Validator.getPattern;
        $scope.minDate = ServerTimeService.time;
        $scope.constants = Const;
        $scope.withdraw = { login: $stateParams.login, amount: $stateParams.amount };
        $scope.modal = { actionText: LocaleService.translation.try_again, state: false };
        $scope.creditCard = { holder: $scope.user.firstName + ' ' + $scope.user.lastName };
        $scope.withdrawalReasonsTypes = Storage.get('withdrawalReasons')
            .map(function (reason) {
                return {id: reason, label: $scope.translation.withdrawalReason[reason]};
            });
        $scope.reasonModel = {};
        $scope.reasonModel.selectedReason = null;

        $scope.isOtherReason = function() {
            return $scope.reasonModel.selectedReason ?
                $scope.reasonModel.selectedReason.id === 'otherReason' : false; };

        $scope.submit = function (form) {
            Utils.formRevalidate(form);
            if (!form.$valid) return;

            var expireDate = ''
            if($scope.creditCard.date){
                var expiryMonth = $filter('date')($scope.creditCard.date, "MM");
                var expiryYear = $filter('date')($scope.creditCard.date, "yyyy");
                expireDate = '{month} {year}'
                    .replace('{month}', parseInt(expiryMonth, 10))
                    .replace('{year}', parseInt(expiryYear, 10));
            }

            var request = {
                login: parseInt($scope.withdraw.login, 10),
                amount: parseFloat($scope.withdraw.amount),
                ccNumber: $scope.creditCard.number || '',
                ccHolder: $scope.creditCard.holder,
                ccCvv: '',
                ccExpiration: expireDate || '',
                reason: $scope.reasonModel.selectedReason.id || '',
                reasonComment: $scope.reasonModel.reasonDescription || ''
            };

            $ionicLoading.show();

            return API.withdrawalCreditCard(request)
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();

                    if(Const.withdrawalComplianceRequired && $scope.user.complianceStatus !== 'approved') {
                        return $state.go('root.app.withdrawCompliance');
                    }

                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = '';
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                    $scope.modal.back = 'root.app.withdraw';
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawalFailed;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || '';
                    $scope.modal.state = true;
                });
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'WithdrawCreditCardController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }
    }]);
